import axios from 'axios';
import config from '../config';
import { RouteCard } from '../interfaces';

export const getRouteCard = (id: string): Promise<RouteCard> => {
    return axios.get(`${config.API_URL}/route-cards/${id}`).then((response: any) => {
        return response.data.data.routeCard;
    });
};
